// Copyright (c) StrangeBee 2024

import { QuerySelector } from 'thehive-sdk';

export const computeListSelector = (): QuerySelector => ({
    head: [{ name: 'listTask' }, { name: 'inCase' }],
    extraData: ['actionRequired', 'shareCount', 'case'],
    name: `get-global-tasks`,
    sort: ['-flag', '-startDate'],
});
